import React, { useState, useEffect } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "../../../../style/dentistmillinglist.css";
import { apiAxios } from "../../../../utils/apiAxios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
const DentistMillingDashboard = () => {

    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    const [tab, setTab] = useState<"dentist" | "milling">("dentist");
    const [search, setSearch] = useState("");

    const [data, setData] = useState<any[]>([]);
    const [stats, setStats] = useState({
        totalDentists: 0,
        activeDentists: 0,
        totalMilling: 0,
        activeMilling: 0,
        millingCases: 0,
        pendingCases: 0
    });

  const [loading, setLoading] = useState(false);
const [page, setPage] = useState(1);
const [totalRows, setTotalRows] = useState(0);

const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState<number | null>(null);

    // ✅ API CALL
    const fetchData = async () => {
        try {
            setLoading(true);

            const res = await apiAxios.get(
                `${API_BASE}/Central/dentist-milling-dashboard`,
                {
                    params: {
                        Type: tab === "dentist" ? "Dentist" : "Milling",
                        Search: search,
                        PageNumber: page,
                        PageSize: 10
                    }
                }
            );

            const response = res.data?.dataOne || {};

            setData(response.data || []);
            setStats(response.stats || {
                totalDentists: 0,
                activeDentists: 0,
                millingCases: 0,
                pendingCases: 0
            });
            setTotalRows(response.totalRecords || 0);

        } catch (err) {
            console.error("API Error:", err);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
    const delay = setTimeout(() => {
        fetchData();
    }, 400);

    return () => clearTimeout(delay);
}, [tab, search, page]);




    // ✅ SINGLE useEffect (Debounce + Tab + Page)
    useEffect(() => {
        const delay = setTimeout(() => {
            fetchData();
        }, 400);

        return () => clearTimeout(delay);
    }, [tab, search, page]);


const confirmDelete = (id: number) => {
    setDeleteId(id);
    setShowDeleteModal(true);
};

const handleDelete = async () => {
    if (deleteId === null) return;

    try {
        const response = await apiAxios.delete(
            `${API_BASE}/Users/DeleteUser/${deleteId}`
        );

        const responseData = response.data;

        if (responseData.isSuccess) {
            toast.success(responseData.status || "User deleted successfully!");

            setShowDeleteModal(false);
            setDeleteId(null);

            // Refresh table
            fetchData();
        } else {
            toast.warning(
                responseData.status || "Unable to delete user."
            );
        }

    } catch (error: any) {
        console.error("Delete User Error:", error);

        if (error.response) {
            const responseData = error.response.data;

            toast.warning(
                responseData.status ||
                responseData.message ||
                "Unable to delete user."
            );
        } else {
            toast.error("Network error. Please try again.");
        }
    } finally {
        setShowDeleteModal(false);
        setDeleteId(null);
    }
};

    // ✅ COMMON COLUMNS (used for both tabs)
const columns: TableColumn<any>[] = [
    {
        name: "Name",
        selector: (r: any) => r.name,
        sortable: true
    },
    {
        name: "Email",
        selector: (r: any) => r.email
    },
    {
        name: "Phone",
        selector: (r: any) => r.phone
    },
    {
        name: "Status",
        cell: (r: any) => (
            <span
                className={`status-pill ${
                    r.status ? "active" : "inactive"
                }`}
            >
                {r.status ? "Active" : "Inactive"}
            </span>
        )
    },
    {
    name: "Action",
    center: true,
    cell: (r: any) => (
        <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            title={r.status ? "Delete User" : "User is inactive"}
            disabled={!r.status}
            onClick={() => confirmDelete(r.id)}
        >
            <i className="bi bi-trash-fill"></i>
        </button>
    )
}
];
    const exportToCSV = () => {
        if (!data || data.length === 0) {
            alert("No data to export");
            return;
        }

        // Define headers
        const headers = ["Name", "Email", "Phone", "Status"];

        // Convert data
        const rows = data.map((item: any) => [
            item.name,
            item.email,
            item.phone,
            item.status ? "Active" : "Inactive"
        ]);

        // Combine headers + rows
        const csvContent =
            "data:text/csv;charset=utf-8," +
            [headers, ...rows].map(e => e.join(",")).join("\n");

        // Create download link
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");

        link.setAttribute("href", encodedUri);
        link.setAttribute(
            "download",
            `${tab}_list_${new Date().toISOString()}.csv`
        );

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const exportToPDF = () => {
        if (!data || data.length === 0) {
            alert("No data to export");
            return;
        }

        const doc = new jsPDF();

   
     doc.setFontSize(16);

const title = `${tab === "dentist" ? "Dentist List" : "Milling List"}`;

doc.text(title, doc.internal.pageSize.getWidth() / 2, 15, {
  align: "center",
});
        // Table headers
        const tableColumn = ["Name", "Email", "Phone", "Status"];

        // Table rows
        const tableRows = data.map((item: any) => [
            item.name,
            item.email,
            item.phone,
            item.status ? "Active" : "Inactive"
        ]);

        // AutoTable
        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 20,
        });

        // Save
        doc.save(`${tab}_list_${new Date().toISOString()}.pdf`);
    };
    return (
        <div className="premium-dashboard dentist-milling-card container-fluid ">

            <h4 className="mb-4">
                Dentist Milling Dashboard
            </h4>

            {/* ✅ STATS */}
            <div className="dashboard-stats">

                {tab === "dentist" && (
                    <>
                        <div className="order-status-bar23 mb-4 row">
<div className="col-md-5 col-6 col-lg-6">
                            <div className="stat-content">

                                <h3></h3>
                                <h6></h6>
                            </div>
                            <div className="stat-box2">
                                <h2 className="stat-number">{stats.totalDentists}</h2>
                                <div className="stat-label blue">
                                    <i className="bi bi-cpu"></i>Total Dentists
                                </div>
                            </div>
</div>
<div className="col-md-5 col-6 mt-1 col-lg-6">
                            <div className="stat-box2">
                                <h2 className="stat-number">{stats.activeDentists}</h2>
                                <div className="stat-label green">
                                    <i className="bi bi-check-circle-fill"></i>Active Dentists
                                </div>
                            </div>
                            <div className="stat-content">

                                <h3></h3>
                                <h6></h6>
                            </div>
                            </div>
                        </div>
                    </>
                )}

                {tab === "milling" && (
                    <>
                        <div className="order-status-bar mb-4">
                            <div className="stat-box2">
                                <h2 className="stat-number">{stats.totalMilling}</h2>
                                <div className="stat-label blue">
                                    <i className="bi bi-cpu"></i> Total Milling
                                </div>
                            </div>

                            <div className="stat-box2">
                                <h2 className="stat-number">{stats.activeMilling}</h2>
                                <div className="stat-label green">
                                    <i className="bi bi-check-circle-fill"></i> Active Milling
                                </div>
                            </div>

                            <div className="stat-box2">
                                <h2 className="stat-number">{stats.millingCases}</h2>
                                <div className="stat-label red">
                                    <i className="bi bi-cpu"></i> Milling Cases
                                </div>
                            </div>

                            <div className="stat-box2">
                                <h2 className="stat-number">{stats.pendingCases}</h2>
                                <div className="stat-label yellow">
                                    <i className="bi bi-clock-history"></i> Pending Cases
                                </div>
                            </div>
                        </div>
                    </>
                )}

            </div>

            {/* ✅ TABS */}
                <div className="row  mb-4">
            <div className="tabs-container">

                <button
                    className={`tab-btn ${tab === "dentist" ? "active" : ""}`}
                    onClick={() => {
                        setTab("dentist");
                        setPage(1);
                    }}
                >
                    <i className="bi bi-person"></i> Dentist List
                </button>

                <button
                    className={`tab-btn ${tab === "milling" ? "active" : ""}`}
                    onClick={() => {
                        setTab("milling");
                        setPage(1);
                    }}
                >
                    <i className="bi bi-cpu"></i> Milling List
                </button>

            </div>

            {/* ✅ SEARCH */}
            <div className="table-toolbar d-flex justify-content-between align-items-center flex-wrap gap-2">

                {/* LEFT */}
                <input
                    placeholder=" Search dentist / milling..."
                    className="glass-search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                {/* RIGHT */}
                <div className="export-group">
                    <button className="btn btn-success" onClick={exportToCSV}>
                        <i className="bi bi-file-earmark-excel-fill me-2"></i>
                        Export Excel
                    </button>


                    <button className="btn btn-danger" onClick={exportToPDF}>
                        <i className="bi bi-file-earmark-pdf"></i> Export PDF
                    </button>
                </div>

            </div>
</div>
            {/* ✅ TABLE (ONE FOR BOTH TABS) */}
                <div className="row  mb-4">
            <div className="premium-card">

                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={(p) => setPage(p)}
                    progressPending={loading}
                    highlightOnHover
                    persistTableHead
                    className="admin-delivery-table"
                />
<Modal
    show={showDeleteModal}
    onHide={() => {
        setShowDeleteModal(false);
        setDeleteId(null);
    }}
    dialogClassName="custom-top-modal"
>
    <Modal.Body className="text-center">
        <p className="fs-6 mb-0">
            Are you sure you want to delete this user?
        </p>
    </Modal.Body>

    <Modal.Footer className="justify-content-center">
        <button
            type="button"
            className="btn py-2 px-3 btn-primary"
            onClick={handleDelete}
        >
            Yes
        </button>

        <button
            type="button"
            className="btn py-2 px-3 btn-secondary mx-2"
            onClick={() => {
                setShowDeleteModal(false);
                setDeleteId(null);
            }}
        >
            No
        </button>
    </Modal.Footer>
</Modal>
            </div>

            {/* ✅ FLOAT BUTTON */}
            <button className="fab-btn">
                <i className="bi bi-plus-lg"></i>
            </button>
</div>
        </div>
    );
};

export default DentistMillingDashboard;